module.exports = __webpack_public_path__ + "static/media/141.87ec5421.mp3";